module.exports = __webpack_public_path__ + "components/incentive/static/extend-2eae14b1f83813daa6703ad49a6b4f42.svg";